export default {
  aaCheckout: {
    title: '乘客资料',
    continue: '继续',
    validateMessage: {
      emailError: '请输入一个有效的电子邮箱地址（如：example@email.com）',
      childAgeError: '在出发当日{age}至{max}周岁(不满)的乘客为儿童乘客',
      familyNameMaxError:
        '已达{number}最高字符限制。请将其余姓氏输入名称栏中。',
      genericMaxError: 'Max allowed character is {max}.',
      adultAgeError: '乘客在出发当日须年满{age}周岁',
      alphanumericError: '请仅使用英文字母(A至Z)及数字，不支持特殊字符或符号。',
      givenNameMaxError: '已达{number}最高字符限制。请将其余名称输入姓氏栏中。',
      mobileNumberError: '请输入有效的手机号码。',
      numericError: '请仅输入数字',
      dateError: '请输入有效的日期',
      totalNameMaxError: '姓氏及名称不可超过{number}总字符。',
      dateExpiredAfter: '您的护照在旅行当日须至少拥有6个月的有效期',
      alphabetError: '请仅使用英文字母(A至Z)，不支持特殊字符或符号。',
      firstNameMaxError: '已达{number}最高字符限制。请将其余名称输入姓氏栏中。',
      infantAgeError: '在出发当日{max}周岁以下的乘客为婴儿乘客',
      dateExpired: '您的旅游文件信息已失效',
      requiredError: '必填项',
      gstError: 'Please enter a valid GSTIN number (e.g. 18AABCU9603R1ZM)',
      vatError: 'Please enter a valid VAT Tin number (e.g. L231231231234)',
      yptaWarning:
        '年龄介于{0}至{1}岁的乘客，请阅读独自旅行青少年乘客规则(YPTA)。',
      yptaValidationMessage:
        '旅行当日年龄介于12至16周岁青少年须携带政府颁发带照片ID，并在父母或监护人的陪同下前往机场值机柜台办理值机。青少年乘客搭乘航班需符合我们的YPTA(独自旅行青少年)政策。',
    },
    guestDetailsForm: {
      adult: '成人',
      child: '儿童',
      infant: '婴儿',
      seniorNoteHeader: '老年人折扣',
      infantSubtitle: '{max} 周岁以下',
      Error: '未正确填写',
      ofwNoteHeader:
        '根据菲律宾共和国法案第8042条(经第10022条修订)，菲律宾海外劳务人员无需支付国际旅客服务费(IPSC)或机场税。\n\n菲律宾海外劳务人员需输入菲律宾海外劳务人员ID以移除预订中的国际旅客服务费。\n\n须于机场出示有效证件以供验证，否则或被处以罚款或被拒绝登机。',
      seniorCitizenId: '老年人ID',
      registeredSenior: '您是拥有注册ID的老年人吗？',
      pwdId: 'PWD ID',
      travelingWith: '同行乘客：{0}',
      id: '身份证',
      yptaDisclaimerText:
        '旅行当日年龄介于12至16周岁青少年须携带政府颁发带照片ID，并在父母或监护人的陪同下前往机场值机柜台办理值机。青少年乘客搭乘航班需符合我们的YPTA(独自旅行青少年)政策。',
      yes: '是的',
      governmentId: 'Government ID',
      Complete: '完整',
      noRightKeywordLabel: '我们无法根据您的搜索找到任何结果',
      expiryDate: '失效日期(自由选填)',
      dateOfBirth: '出生日期',
      passport: '护照',
      ypta: 'Young passenger travelling alone',
      passportDetails: '旅游文件信息',
      ToComplete: '待填写',
      childSubtitle: '{age} - {max}周岁',
      searchNationality: '按国家/地区搜索',
      yptaDisclaimerTitle: '独自旅行青少年乘客',
      ofwId: 'OFW ID',
      pwdNoteHeader:
        '根据经共和国法令(R.A.) 10754修订的第7277扩大残疾人 (PWD) 福利和特权法案，残疾人士输入残疾人士卡号可尊享国内航班基本票价8折优惠。残疾人士须在值机柜台出示残疾人士卡以及任何有效身份证件以供验证，否则或需支付1,500菲律宾比索罚款及票价差额或被拒绝登机。\n  requiredError: 此字段为必填字段。',
      seniorNote:
        '根据菲律宾相关法规，60岁以上的年长公民可以凭借自己的Senior Citizen ID享受菲律宾境内航班基础航费8折优惠。年长公民须在值机柜台出示自己的Senior Citizen证书及相关有效身份证件。若不能出示自己的Senior Citizen证书及相关有效身份证件，则会面临1,500菲律宾比索的罚款，同时须补齐航费差价，或被拒绝登机。',
      familyName: '姓氏',
      visaDisclaimerContent: '请确保您持有进入中转及/或最终目的地的旅游文件。',
      dateFormat: '日日/月月/年年年年',
      adultSubtitle: '{age}周岁级以上',
      popoverTitle: '姓名填写指南',
      nationality: '国籍/地区',
      isOfw: '您属于菲律宾海外劳工（OFW）吗？',
      Incomplete: '不完整',
      gender: '性别',
      clear: '清除',
      expiredError: '护照已失效',
      expiryDateRequired: '失效日期',
      no: '不是',
      personalDetails: '个人信息',
      passportNumber: '护照/身份证号码',
      documentNumber: '身份证号码',
      type: '旅行证件类型',
      docNumber: '身份证号',
      yptaDisclaimerReadMore:
        '阅读更多 https://support.airasia.com/s/article/Are-children-allowed-to-travel-alone?language=zh_CN',
      givenName: '名',
      registeredPwd: '您是注册的残疾人士吗？',
      popoverMessage:
        '姓名须与身份证件或护照上的英文字母(A至Z)一致，不支持特殊字符或符号。若您的姓名仅有1个字，请将其填写在姓氏及名称中。',
      visaDisclaimerTitle: '您或许需要为本次旅行办理签证。',
    },
    guestContactForm: {
      mobileNumber: '手机号码',
      countryCode: '电话代码',
      primaryContact: '主要联系方式',
      contactDetails: '联系方式',
      helpText: '我们会向您的电子邮箱及手机发送预订确认及任何更新信息。',
      salutation: '称呼',
      makeLabel: ['将{{name}}设为联系人', { name: '' }],
      email: '电子邮箱',
    },
    ancillary: {
      baggage: {
        baggageExperience: {
          budnleInclude: '常飞客包含 {1} 公斤托运行李限额。',
          depart: '出发航班',
          handCarryToolTipLabel:
            '这是您可以带入飞机的行李。您须将其存放入客舱行李架中。',
          return: '往返航班',
          sportsEquipmentLabel: '我需要运输体育器材',
          buttonTitle: '添加行李限额',
          submitButtonTitle: '完成',
          total: '总价',
          chooseSelection: '选择行李',
          handCarry: '手提包',
          title: '行李',
          summaryButtonText: '变更',
          handCarryToolTipTitle: '什么是手提行李？',
          notificationMessage: '我们已为您预先选定行李',
          checkBoxTitle: '为全部乘客选择一样的行李限额',
          sportsEquip: '运动装备',
          includedIcon: '包含于增值服务套餐中',
          includedBaggage:
            '提前预订价格最优惠，所示价格适用于您行程中的全部航班。',
          bundle: '套餐',
          included: '包括',
          handCarrySizeDesc: '每件行李尺寸不得超过56 x 36 x 23厘米',
          tileDescription:
            '提前预订价格最优惠，所示价格适用于您行程中的全部航班。',
          none: '无',
          priceDescription: '行李限额总费用',
          checkedBaggage: '托运行李',
          nextFlightButtonTitle: '下趟航班',
        },
      },
      insurance: {
        benefitsSubtitle: '{total_benefits} benefits大福利',
        continueWithInsuranceCta: '添加保险',
        continueWithoutInsuranceCta: '不添加保险，继续下一步',
        priceSubtitle: '适用{total_pax}名乘客',
        headerTitle: '保险',
        readMoreText: '了解详情',
        paxCount: '适用{paxcount}名乘客',
        headerMessage: '防止旅行意外情况。',
        termsText: '选择保险即代表我同意',
        termsAndConditionCloseButtonText: '关闭',
        discountedPercentage: '{discountedPercent}%折扣',
        termsLinkText: '条款与条件',
      },
      wheelchairSelector: {
        unavailablePrimaryBtn: '在没有轮椅服务下继续',
        nextFlightButtonTitle: '下趟航班',
        pwdNoteTitle: '什么是PWD ID？',
        pwdNote:
          'PWD ID是残疾人身份证明。您需要在柜台办理值机时出示此证件以确认其有效性。我们将在机场收取适用的费用。',
        buttonTitle: '申请',
        pwdSubTitle: '如果您有残疾人身份证，我们将免除轮椅服务费用。',
        cardDescription: '特殊需求乘客额外支持',
        needWheelchair: '我需要轮椅',
        unavailable: '不可选',
        title: '特殊帮助',
        wheelchairAvailabilityErrorTitle: '抱歉，出现错误！',
        submitButtonTitle: '完成',
        unavailableSubTitle1:
          '由于无法提供为本次旅程选择的轮椅，我们已从您的预订中删除了该选项。',
        errorTextTitle: '无法预订特殊帮助',
        available: '剩余{0}个',
        pwdFooter:
          '在特殊情况下，我们可能接受托运移除电池的电动轮椅或行动辅助器具（乘客需自行移除电池），且轮椅或行动辅助器具的重量限额为 85 公斤 。',
        readMore: '了解详情',
        pwdTitle: '输入您的PWD ID(可选)',
        ownWheelchair: '我自己有轮椅',
        noWheelchairOptionLabel: '我有自己的轮椅，不需要帮助',
        waiveWheelchairFee: '已免除轮椅费',
        unavailableSubTitle2:
          '您可以在没有轮椅的情况下继续前往支付页面，或选择其他可提供轮椅服务的航班。',
        pwdTextLabel: '身份证号码',
        unavailableSecondaryBtn: '变更航班',
        errorTextMessage: '可于机场进行申请，先到先得',
        wheelchairAvailabilityErrorMessage:
          '加载特殊帮助时出现问题，请刷新页面！',
        wheelchairFooterMessage: '机场供应轮椅数量有限，先到先得',
        priceDescription: '轮椅总费用',
        refresh: '更新',
        backToAddons: '返回增值服务',
        unavailableTitle: '无法提供轮椅服务',
        total: '总价',
        summaryButtonText: '变更',
      },
      meal: {
        errorTextTitle: '错误',
        errorTextMessage: '加载座位数据时发生错误，请重新尝试！',
      },
      seat: {
        notAvailabeError: '很抱歉，此航班暂不提供座位选择！',
        loadDataError: '加载座位数据时发生错误，请重新尝试！',
      },
      seatSoldout: {
        soldoutSeatHeader: '很抱歉！我们已售光所有的座椅:(',
        soldoutSeatDesc: '我们已售光所有的座椅，请尝试重新选择其他航班',
        soldoutSeatCTA: '确定',
      },
      flatbedSoldout: {
        soldoutTitle: '很抱歉！我们已售光所有的平躺座椅:(',
        soldoutSubtitle: '请尝试购买非平躺座椅，或重新选择其他航班',
        soldoutEconomyCta: '确定',
      },
      bundleSeatSoldout: {
        soldOutBundleHeading: '我们已售光所有的套餐座椅:(',
        soldOutBundleMain: '请尝试购买其他套餐，或重新选择其他航班',
        soldOutBundleCTA: '确定',
      },
    },
    familyAndFriends: {
      maxSelectedText:
        '最多可选择{0}位乘客（包括成人，儿童，婴儿），请取消选择乘客以选择新乘客',
      selectedCountText: '最多可选择{0}位乘客',
      title: '家人和朋友',
    },
    bigMember: {
      search: '搜索',
      unavailable: '不可选',
      searchSubtitle: '通过该乘客的注册电子邮箱地址搜索亚航会员ID',
      points: '积分',
      earnBigPoints: '通过此预订赚取亚航积分',
      earnBigPointsGuest: '为此乘客赚取亚航积分',
      earnUpTo: '最多可赚取积分',
      detailedInvalidEmailMessage:
        '请输入一个有效的电子邮箱地址（如：example@email.com）',
      noData: '我们无法找到您的亚航会员ID。请再次尝试。',
      bigMemberId: '亚航会员ID',
      placeholder: '邮件地址(可选)',
    },
    sessionTimerPopup: {
      title: '对话已终止',
      subTitle: '有阵没来啦？没关系，马上搜索新航班了解最新航费！',
      primaryButtonTitle: '再次搜索',
    },
    sessionTimer: {
      min: '分',
      secLeft: '秒',
    },
    errors: {
      formError: '请填写标出部分以继续',
      dateOfBirthError: [
        '以下乘客的出生日期填写不正确：{{names}}，正确的日期格式应为DD/MM/YYYY',
        { names: '' },
      ],
      expiryDateError: [
        '以下乘客的旅行证件失效日期填写不正确：{{names}}，正确的日期格式应为DD/MM/YYYY',
        { names: '' },
      ],
      duplicatedTravelDocError: [
        '以下乘客的旅行证件号码填写重复：{{names}}',
        { names: '' },
      ],
      duplicatedNameAndDOBError: [
        '以下乘客的姓名和出生日期填写重复：{{names}}',
        { names: '' },
      ],
      invalidNationalityError: [
        '请重新选择以下乘客的“国籍/地区”：{{names}}',
        { names: '' },
      ],
      infantChildWithNoAdultError: '婴儿和儿童必须在18岁以上成人的陪伴下旅行',
      checkoutUnknownError: '未知异常错误，请重新尝试。',
      priceValidationError: '价格验证失败！请尝试重新搜索。',
    },
    bundleSelector: {
      subHeader: '增值服务套餐比单个购买更加优惠',
      baggageEmpty: '此航班不支持托运行李',
      isIncluded: 'Included',
      subTitle: '',
      guest: '{0} 乘客',
      title: '增值服务套餐',
      removeBundleSubtitle: '需从预订中删除增值服务套餐',
      compareBundleTitle: '比较套餐福利',
      bundles: '套餐',
      bundleErrorSubtitle: 'You can continue with an economy fare',
      upgradeTo: 'Upgrade to',
      bundleTitle: '增值服务',
      bundleErrorCTA: 'Got it',
      eachPax: 'Each pax',
      close: '关闭',
      removeBundle: '删除套餐',
      bundleErrorTitle: "We can't add premium flatbed in your booking",
      mealEmpty: '删除套餐',
      subHeaderUnavailable: '此航班不提供套餐',
    },
    fastPass: {
      unavailablePrimaryBtn: '无通行证继续操作',
      priceDescription: '总价',
      priceFrom: '从',
      title: 'FastPass',
      nextFlightButtonTitle: '下趟航班',
      tagline: '数量有限',
      errorMessage: '抱歉，该乘客已无法再次购买通行证。',
      promptPurchase:
        'More value! 7 kg Xtra Carry-on, priority boarding and check-in.',
      unavailableTitle: '{0} - {1}航班快速通行证已售罄。',
      unavailableSubtitle:
        '我们为该航班提供的快速通行证数量有限，您可以在没有通行证的情况下继续支付或编辑您的选择。',
      promptPurchaseCTA: 'Upgrade to Fast Pass',
      unavailableSecondaryBtn: '编辑选择',
      buttonTitle: '添加快速通行证',
      submitButtonTitle: '完成',
    },
    seatSelector: {
      emergencyWarningTitle: '紧急出口排座位',
      hotSeatName: '热选座位',
      hotSeatDesc: '机舱前部热选座位，包含优先登机特权。',
      bundlePremiumFlatbed: '豪华平躺座椅',
      seatBundleMandatoryError: '选择座位 {bundleName} 以继续',
      quietZoneHeader: '无法分配安静区座位',
      seats: '座位',
      emergencySelectDiffSeat: '选择不同座位',
      bundleNotification: '{0}包含于 {1} 。',
      legendBlocked: '已中止',
      standardSeatFrontRowName: '普通座位(前排)',
      soldoutSeatCTA: '选择其他航班',
      done: '完成',
      soldoutSeatHeader: '抱歉，座位已售罄！',
      hotSeatEmergencyRowName: '热选座位(紧急出口排)',
      total: '总价',
      buttonTitle: '选择座位',
      nextFlight: '下趟航班',
      emergencyWarningNote2: '年满15周岁',
      emergencyWarningNote3: '能够理解书面/口头紧急指示',
      emergencyWarningNote1: '身心健康，可在紧急情况下协助机组人员',
      emergencyWarningNote6: '未购买额外座位',
      emergencyWarningNote4: '未处于任何怀孕阶段',
      title: '选择座位',
      summaryButtonText: '添加',
      toolTipContent:
        '{0}包含在每位乘客{1}套餐内。请于搭乘下一趟航班之前，为有需要的乘客选择座位。',
      bundleValuePack: 'Value Pack',
      standardSeatFirstRowDesc: '机舱前部普通座位',
      standardSeatFirstRowName: '普通座位(第一排)',
      hotSeatFirstRowDesc: '热选座位提供额外腿部空间及优先登机特权',
      legendBassinet: '婴儿摇篮',
      hotSeatFirstRowName: '热选座位(第一排)',
      hotSeatFrontRowDesc: '热选座位提供额外腿部空间及优先登机特权',
      toolTipHeader: '为所有乘客选择座位',
      quietZoneCTA: '请选择其他座位',
      notificationAutoSelect: '如果您不选择座位，我们将自动为您分配座位。',
      flatbedName: '豪华平躺座椅',
      soldoutSeatDesc: '本航班最后一个座位已被他人预订，请选择其他航班！',
      emergencyWarningDesc:
        '出于安全原因，若不符合以下紧急出口排资格，我们的机组人员保留在飞机上为您分配新座位的权利：',
      standardSeatDesc: '普通座位 - 招牌黑皮座椅',
      description: '请选择您的座位，或者我们将随机为您分配座位',
      includedIcon: 'Included in add-ons bundles',
      quietZoneDesc: '安静区座位不适用于以下乘客：',
      standardSeatName: '普通座位',
      bundleSelectSeat: '选择座位',
      legendSelected: '您的选择',
      bundlePremiumSeat: '座位选择',
      standardSeatFrontRowDesc: '普通座位 - 招牌黒皮座椅，靠背不可调节。',
      priceDesc: '已选择{1}个座位中的{0}个座位',
      hotSeatEmergencyRowDesc:
        '热选座位提供额外腿部空间及优先登机特权。靠背不可调节。',
      included: '包括',
      bundleStandardSeat: '普通座位',
      legendUnavailable: '不可选',
      modalConfirm: '确认',
      bundlePremiumFlex: 'Premium Flex',
      flatbedDesc: '豪华平躺座椅 - 调节至平躺模式，享受至尊飞行体验。',
      bundleSelecPreferredSeat: '选择您喜欢的座位',
      emergencyWarningNote5: '未与婴儿同行',
      legendBundleIncludes: 'Seat selection is included in {bundleName}',
      bundleFlatbedSeat: '豪华平躺座椅',
      quietZone: '安静区座位不适用于以下乘客：',
      selectFor: '座位选择',
      quietZoneNote1: '10周岁以下乘客',
      quietZoneNote2: '携带婴儿旅行乘客',
      nonAAFlightFareSummaryLabel: '安静区 - 最小噪音，更少干扰',
      hotSeatFrontRowName: '热选座位(前排)',
    },
    mealSelector: {
      mealApiError: '此航班不提供餐食',
      priceFrom: '从',
      nextFlightButtonTitle: '下趟航班',
      prebookMealUnavailable:
        "We don't have any meals available to pre-book on this flight. You can still purchase on board.",
      total: '总价',
      buttonTitle: '添加机餐',
      submitButtonTitle: '完成',
      bundleTitleDescription: '为{pax_first_name}选择机餐',
      notificationBannerLiner: '常飞客包含机餐，请选择机餐后继续',
      title: 'Santan超值套餐',
      summaryButtonText: '添加',
      mealNote: '每趟航班最多可预订2份机餐',
      complimentaryMealLiner: '1包含常飞客份餐点',
      mealPreSelectionLiner: '每位乘客可预订2份机餐/每趟航班',
      errorTextTitle: '此航班不提供餐食',
      selectMealAlrtText:
        '超值套餐中为每位乘客提供一份机餐。请于搭乘下一趟航班之前，为有需要的乘客选择机餐。',
      includedMeals: '选择套餐包含的{meal_count}份机餐',
      bundleSuffix: '(套餐)',
      bundle: '套餐',
      selectMealAlrtTitle: '为所有乘客选择机餐',
      included: '包括',
      complimentaryMealIncluded:
        'Enjoy complimentary meals/snacks and purchase additional meals on board. No pre-book meals available. ',
      errorTextMessage: '若您希望购买机餐，可在登机后进行购买',
      defaultBundleSubtitle: 'Bundle',
      tileDescription: '提前预订最优惠，所示价格适用您行程中的全部航班。',
      mealUnavailable: '机餐不适用于24小时内起飞的航班',
      priceDescription: '机餐总价格',
      bundleMealSelectSubTitle: 'You can select 1 more meal for this guest',
      bundleMealSubTitle: 'One meal is included in {bundleTitle}',
      bundleSubTitle:
        '现在购买节省更多！飞机上购买价格更高！每位乘客最多可选择2份机餐。',
      vegetarian: '素食',
    },
    discount: {
      priceSlashLabel: '折扣',
    },
    journey: {
      kiwiGuaranteeCTA: 'Kiwi.com保障',
      via: '',
      depart: '出发',
      layover: '经停',
      flight: '航班',
      nonStop: '直飞',
      selfTransfer: '经由自行中转',
      selfTransferVia: '',
      singleStop: '1转机',
      protectionByStr: '中转航班由{0}提供保障',
      economy: '经济舱',
      return: '回程',
      business: '商务舱',
      multiStop: '{stop}转机',
      day: '日',
      minute: '分钟',
      selfTransferRequired: '',
      hour: '小时',
      carrier: '航空公司',
      technicalStop: '这是技术性停留，您无需变更航班。',
      premium: '豪华经济舱',
      stopAt: '{1}停留{0}次',
      first: '头等舱',
      operated: '运营：',
      dateFormat: 'M月D日 (ddd)',
      anotherMultiStop: '转机',
    },
    fareSummary: {
      FlightSummaryTitle: '航班信息',
      fareSummaryTitle: '航费总览',
      fareDiscount: '航费折扣',
      serviceCharge: '服务费',
      taxes: '税费, 费用\u0026附加费',
      baseFare: '基础费',
      fareChange:
        '我们的票价可能已经改变。重新搜索，看看我们最新的票价和可用性。',
      processingFee: '手续费',
      totalAmount: '支付总额',
      addOns: '增值服务',
      expand: '显示更多',
      collapse: '精简显示',
    },
  },
};
